import React from 'react'

import Icon, { EIconId } from '../../../../components/icons'

import ELocale from '../../../../types/locales'
import { TItem } from '../../types'

const className = 'w-48 mx-auto'

const items: TItem[] = [
  {
    icon: <Icon id={EIconId.HEADPHONE} className={className} />,
    label: 'Gebührenfreie Bestell-Hotline',
    url: {
      [ELocale.DE_AT]: '+43-800-29-88-88',
      [ELocale.DE_CH]: '+41-800-29-88-88',
      [ELocale.DE_DE]: '+49-800-29-888-88',
    },
  },
  {
    icon: <Icon id={EIconId.EASY} className={className} />,
    label: 'Gebührenfreie EASy-Bestellung',
    url: {
      [ELocale.DE_AT]: '+43-800-29-88-82',
      [ELocale.DE_CH]: '+41-800-29-888-29',
      [ELocale.DE_DE]: '+49-800-29-888-29',
    },
  },
  {
    icon: <Icon id={EIconId.EMAIL} className={className} />,
    label: '24/7 E-Mail-Service',
    url: {
      [ELocale.DE_DE]: 'service@hse.de',
      [ELocale.DE_AT]: 'service@hse.at',
      [ELocale.DE_CH]: 'service@hse24.ch',
    },
  },
]

export { items }
